import React from 'react';
import '../../styles/whoweare.css'
import AnimationBox from '../../animationBox';
import myvideo from '../../assets/sustainability.mp4'


const Sustainablility = () => {

    return(<div style={{maxHeight:'55rem'}} className='whoweare'>

           <AnimationBox>
            <div className='whoweare-outer' >
            <div className='whoweare-inner' >
            
            <div className='myservices' style={{display:'flex',padding:'25px',borderBottom:'1px solid #383838',gap:'10px'}}>
                        
                        <h4 style={{color:'#FFD52B'}}>Sustainability</h4>
                        
            </div>
            <div className='myservices' style={{display:'flex',padding:'25px',gap:'10px',paddingTop:"25px"}}>
                        
                        <div className='services-msg' style={{textAlign:'left'}}>
                            <div style={{display:'flex' , alignItems:'start', justifyContent:'space-between'}}><h1 style={{fontWeight:"600"}}>Committed to Sustainability</h1> <div className='button1'> </div> </div>
                            <p style={{color:'white', fontSize:"14px"}}>At Co6 Group, we prioritize eco-friendly sourcing and sustainable practices to protect the planet while delivering the finest products to our clients.</p>
                            <div className='button2'></div> 
                        </div>
            </div>
            <div style={{display:'flex', alignItems:'center',justifyContent:'center'}}>
            <div className='whowearevideo' style={{width:'100%', height:'20rem'  ,overflow:"hidden", borderRadius:'8px'}}>
            <video autoPlay muted loop style={{objectFit:'cover',width:'100%',height:'100%'}}>
             <source src={myvideo} type="video/mp4" /></video>
            
            </div>
            </div>

            </div>
            </div>
        
            </AnimationBox>

    </div>);

}

export default Sustainablility;